<template>
  <div></div>
</template>
<script>
export default {
  name: 'fbq',
  data () {
    return {
      pixel: null,
      url: null,
    }
  },
  created () {
    this.$analytics.fbq.init('2487666051557981')
    this.$analytics.fbq.event('ViewContent', {
      content_name: 'Really Fast Running Shoes'
    })
    this.pixel = this.$route.query.pixel || null
    this.url = this.$route.query.url || null
  },
  mounted () {
    if (this.url) {
      window.location = this.url
    }
  }
}
</script>
